// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { StatusBanner } from '@loa/ui-components';
import type { CompletionClient } from '../WizardContext';

export interface CompletionSuccessBannerProps {
  profileName: string;
  clients: CompletionClient[];
}

export const CompletionSuccessBanner = ({
  profileName,
  clients,
}: CompletionSuccessBannerProps) => {
  const clientCount = clients.length;
  const clientText = clientCount === 1 ? '1 client' : `${clientCount} clients`;

  return (
    <StatusBanner
      variant="success"
      position="inline"
      visible
      dismissible={false}
      message={
        <>
          <strong>Relationship Created Successfully</strong> — <strong>{profileName}</strong> has been created with {clientText}. You can now send invitation emails to your clients.
        </>
      }
    />
  );
};

export default CompletionSuccessBanner;
